export default [
  'created',
  'inserted'
]
